import React, { useRef } from "react"
import styled from "styled-components"
import { Search, Globe } from "lucide-react"
import { useCRUDController, ImageFileId } from "../../ui/ot"
import { useEffect } from "react"
// 樣式元件
const Section = styled.section`
  width: 100%;
  padding: 2rem 0;
  background-color: #f8fafc;
`

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e40af;
  text-align: center;
  margin-bottom: 1.5rem;
`

const ScrollWrapper = styled.div`
  position: relative;
`

const Grid = styled.div`
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  padding-bottom: 0.5rem;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

const ArrowButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: #ffffffdd;
  border: none;
  border-radius: 9999px;
  width: 32px;
  height: 32px;
  display: none;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  z-index: 1;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    color: #1e3a8a;
  }

  @media (min-width: 1024px) {
    display: flex;
  }
`

const LeftArrow = styled(ArrowButton)`
  left: -16px;
`

const RightArrow = styled(ArrowButton)`
  right: -16px;
`

const Card = styled.div`
  flex: 0 0 auto;
  width: 180px;
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 1rem;
  text-align: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  }
`

const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 32px;
    height: 32px;
    color: #1e3a8a;
  }
`

const CardImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  margin: 0 auto 0.75rem;
`

const CardTitle = styled.h3`
  font-size: 0.95rem;
  font-weight: 600;
  color: #1e3a8a;
  margin-bottom: 0.5rem;
`

const CardContent = styled.p`
  font-size: 0.75rem;
  color: #6b7280;
  margin-bottom: 0.75rem;
`

const LinkButton = styled.a`
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 500;
  background-color: #2563eb;
  color: white;
  padding: 0.35rem 0.75rem;
  border-radius: 0.375rem;
  text-decoration: none;

  &:hover {
    background-color: #1d4ed8;
  }
`

const quickLinks = [
  { img: "icon", title: "館藏查詢", description: "瀏覽圖書與電子資源", href: "https://afats.nknu.edu.tw/library/online_public_catalog_query_construction" },
  { img: "/i2.png", title: "尖端軍事資料庫", description: "整合軍事研究資源", href: "https://www.dtmdatabase.com/" },
  { img: "/i3.png", title: "華藝線上圖書館", description: "期刊全文與學術資源", href: "https://www.airitilibrary.com/" },
  { img: "/i8.jpeg", title: "華藝電子書", description: "台灣最大繁中電子書平台", href: "https://www.airitibooks.com/Home/Index" },
  { img: "/udn.png", title: "udn電子書", description: "數位閱讀服務", href: "https://reading.udn.com/udnlib/afats" },
  { img: "/i4.svg", title: "Science Direct", description: "國際理工醫學全文資料庫", href: "https://www.sciencedirect.com/" },
  { img: "/i5.png", title: "HyRead 電子書", description: "上萬本中文電子書", href: "https://ebook.hyread.com.tw/" },
  { img: "/i6.jpg", title: "KONO 電子雜誌", description: "熱門雜誌多平台支援", href: "https://library.thekono.com/afats/libraries/chinese" },
  { img: "/emerald.jpg", title: "Emerald", description: "學術與實務研究資源", href: "https://www.emerald.com/insight/" },
  { img: "icon", title: "航空技術學院", description: "課程與行政資訊", href: "https://www.afats.khc.edu.tw/" },
]

const QuickLinksSection = () => {
  const scrollRef = useRef(null)

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      })
    }
  }
  const RwdFunctioncontroller = useCRUDController({
    apiRoute: "/app/rwd_function",
    onBefore: () => { }
  })
  useEffect(() => {
    RwdFunctioncontroller.getData({})
  }, [])

  return (
    <Section>
      <Container>
        <Title>快速連結</Title>
        <ScrollWrapper>
          <LeftArrow onClick={() => handleScroll("left")}>
            <svg viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </LeftArrow>
          <RightArrow onClick={() => handleScroll("right")}>
            <svg viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </RightArrow>
          <Grid ref={scrollRef}>
            {RwdFunctioncontroller?.ResponseData.map((link, idx) => {
              let file_data = link?.file_data || []
              let file_id = file_data.find((e) => true)?.file_id
              return (<Card key={idx}>
                {!file_id   ? (
                  <IconWrapper>  <Globe /> </IconWrapper>
                ) : (
                  <ImageFileId file_id={ file_id}  className="w-12 h-12 object-contain mx-auto mb-3" />
                  // <CardImage src={link?.img} alt={link?.rwd_function_name} />
                )}
                <CardTitle>{link?.rwd_function_name}</CardTitle>
                {link?.description && <CardContent>{link?.description}</CardContent>}
                <LinkButton href={link?.rwd_function_url} target="_blank" rel="noopener noreferrer">前往</LinkButton>
              </Card>)
            })}
            {/* {quickLinks.map((link, idx) => (
              <Card key={idx}>
                {link?.img === "icon" ? (
                  <IconWrapper>{idx === 0 ? <Search /> : <Globe />}</IconWrapper>
                ) : (
                  <CardImage src={link?.img} alt={link?.title} />
                )}
                <CardTitle>{link?.title}</CardTitle>
                {link?.description && <CardContent>{link?.description}</CardContent>}
                <LinkButton href={link?.href} target="_blank" rel="noopener noreferrer">前往</LinkButton>
              </Card>
            ))} */}
          </Grid>
        </ScrollWrapper>
      </Container>
    </Section>
  )
}

export default QuickLinksSection
